export default {
    header_change_password: "Cambiar contraseña",
    header_logout: "Cerrar sesión",
    header_pay_credit: "Paga tu crédito aquí"
}